export enum IconType{
    analysis = "analysis",
    analysisActive = "analysis-active",
    arrow = "arrow",
    bell = "bell",
    bellActive = "bell-active",
    buttonAccept = "button-accept",
    calendar = "calendar",
    chart = "chart",
    chevron = "chevron",
    cross = "cross",
    expand = "expand",
    filter = "filter",
    home = "home",
    homeActive = "home-active",
    info = "info",
    logo = "logo",
    logoWide = "logo-wide",
    logout = "logout",
    logoutActive = "logout-active",
    menuToggle = "menu-toggle",
    message = "message",
    messageActive = "message-active",
    plus = "plus",
    projects = "projects",
    projectsActive = "projects-active",
    settings = "settings",
    settingsActive = "settings-active",
    statusOk = "status-ok",
    sum = "sum",
    user = "user",
    ok = "ok",
    time = "time",
}